import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef, userCreateRouteRef } from './routes';

export const usersPlugin = createPlugin({
  id: 'users',
  routes: {
    root: rootRouteRef,
    create: userCreateRouteRef,
  },
});

export const UsersPage = usersPlugin.provide(
  createRoutableExtension({
    name: 'UsersPage',
    component: () =>
      import('./components/IndexPage').then(m => m.IndexPage),
    mountPoint: rootRouteRef,
  }),
);
